import React, { ComponentProps, FunctionComponent } from "react";

const EditIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      stroke: "currentColor",
      d: "M3 14H13",
    }),
    React.createElement("path", {
      fill: "currentColor",
      d: "M12.8375 4.24552C13.0542 4.02888 13.0542 3.66782 12.8375 3.4623L11.5377 2.16248C11.3322 1.94584 10.9711 1.94584 10.7545 2.16248L9.7324 3.179L11.8154 5.26205M3 9.91696V12H5.08304L11.2266 5.85085L9.14359 3.76781L3 9.91696Z",
    })
  );
};

const ForwardRef = React.forwardRef(EditIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
